import './QualitativeIndicatorFields.css';

import React, { useState } from 'react';
import { generateClassName, generateSelectField } from '../../../b2b-common/helpers';
import useQualitativeTypes from '../../hooks/useQualitativeTypes';
import { Info, List } from '@mui/icons-material';
import WeightedValuesTable from '../WeightedValuesTable';

const QualitativeIndicatorFields = ({ indicator, setIndicator, className = null }) => {
    const qualitativeTypes = useQualitativeTypes(true);
    const [isInfoHovered, setIsInfoHovered] = useState(false);
    const [isListValuesHovered, setIsListValuesHovered] = useState(false);
    const isUsed = indicator && indicator.areaIndicatorDTOs && indicator.areaIndicatorDTOs.length > 0;

    if (!qualitativeTypes) {
        return null;
    }

    const qualitativeTypesList = qualitativeTypes.map((type) => {
        return {
            value: type.qualitativeTypeId,
            label: type.qualitativeTypeName
        };
    });

    const handleChangeQualitativeType = (event) => {
        const qualitativeTypeId = event.target.value;
        const qualitativeType = qualitativeTypes.find((type) => type.qualitativeTypeId === qualitativeTypeId);
        setIndicator({ ...indicator, qualitativeTypeDTO: qualitativeType });
    }

    return (
        <div className={generateClassName('qualitative-indicator-fields', '', className)}>
            {generateSelectField(qualitativeTypesList,
                {
                    label: 'Qualitative Type',
                    value: indicator.qualitativeTypeDTO?.qualitativeTypeId,
                    onChange: handleChangeQualitativeType,
                    className: 'qualitative-indicator-type',
                    disabled: isUsed
                }
            )}
            <div
                onMouseOver={() => setIsInfoHovered(true)}
                onMouseOut={() => setIsInfoHovered(false)}
                className='qualitative-indicator-type-info'
            >
                <Info />
            </div>
            <div
                onMouseOver={() => setIsListValuesHovered(true)}
                onMouseOut={() => setIsListValuesHovered(false)}
                className='qualitative-indicator-list-values'
            >
                <List />
            </div>
            {isInfoHovered && (
                <div className='qualitative-indicator-type-info-tooltip'>
                    {indicator.qualitativeTypeDTO?.qualitativeTypeDescription}
                </div>
            )}
            {isListValuesHovered && (
                <div className='qualitative-indicator-list-values-tooltip'
                    style={{ height: 'auto' }}
                >
                    <WeightedValuesTable qualitativeWeightedValues={indicator.qualitativeTypeDTO?.weightedValues} />
                </div>
            )}
        </div>
    );
}

export default QualitativeIndicatorFields;